export enum TransmitterType {
	Handheld = 'hh',
	Bodypack = 'bp',
	Boundary = 'bn',
	Gooseneck = 'gn',
	None = ''
}
